import * as React from "react"

const IconInformation = (props) => (
  <svg
    width={20}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m17.125 14.255-5.087-7.987a2.384 2.384 0 0 0-2.032-1.112c-.83 0-1.584.422-2.032 1.112l-5.086 7.987a2.355 2.355 0 0 0-.077 2.454 2.4 2.4 0 0 0 2.11 1.253H15.08a2.37 2.37 0 0 0 2.109-1.253c.434-.78.408-1.7-.064-2.454ZM9.38 8.875a.627.627 0 0 1 1.253 0v3.745a.627.627 0 0 1-1.253 0V8.875Zm.614 6.863a.93.93 0 0 1-.933-.933c0-.511.421-.933.933-.933.51 0 .933.422.933.933a.93.93 0 0 1-.933.933Z"
      fill="#141938"
    />
  </svg>
)

export default IconInformation